import { WorkplaceRequestElement } from "@gettactic/api";

/** Narrow an unknown value to a renderable {@link WorkplaceRequestElement}. */
export function isValidWorkplaceRequest(
  request: unknown
): request is WorkplaceRequestElement {
  if (!request || typeof request !== "object") return false;
  const r = request as Record<string, unknown>;
  return (
    typeof r.id === "string" &&
    typeof r.title === "string" &&
    typeof r.status === "string" &&
    typeof (r.type as Record<string, unknown> | undefined)?.id === "string"
  );
}
